import PendingRequests from 'services/localDB/pendingRequests';
import LastInvoiceNumbers from 'services/localDB/lastInvoiceNumbers';
import LastReceiptData from 'services/localDB/lastReceiptData';
import OfflineLogin from 'services/localDB/offlineLogin';

export const pendingRequests = new PendingRequests();
export const lastInvoiceNumbers = new LastInvoiceNumbers();
export const lastReceiptData = new LastReceiptData();
export const offlineLogin = new OfflineLogin();
